import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/Button';
import { useBooking } from './BookingContext';
export function RSVPSection() {
  const {
    openBooking
  } = useBooking();
  return <section id="rsvp" className="relative py-24 md:py-32 bg-bc-surface" data-id="element-161">
      <div className="container mx-auto px-6" data-id="element-162">
        <div className="max-w-2xl mx-auto" data-id="element-163">
          <div className="bg-bc-card border border-bc-pink bc-glow-box-soft rounded-bc p-8 md:p-12 text-center" data-id="element-164">
            {/* Eyebrow */}
            <div className="text-bc-pink font-sans text-sm md:text-base tracking-wide2 uppercase mb-4" data-id="element-165">
              RSVP
            </div>

            {/* Headline */}
            <h2 className="font-display font-extrabold text-3xl md:text-4xl text-bc-bone mb-4" data-id="element-166">
              RESERVE YOUR PLACE
            </h2>

            {/* Short line */}
            <p className="text-bc-bone-2 font-sans text-lg md:text-xl leading-relaxed mb-8 max-w-md mx-auto" data-id="element-167">
              We'd love to see you there. Reserve your spot below, or call us on
              925-215-1160.
            </p>

            {/* CTA */}
            <div className="flex flex-col items-center gap-4" data-id="element-168">
              <Button onClick={openBooking} className="w-full sm:w-auto h-14 rounded-full bg-transparent border border-bc-pink text-bc-bone text-base tracking-label uppercase bc-glow-box hover:bc-glow-box-soft transition-all bc-ease px-10" data-id="element-169">
                RESERVE MY SPOT
                <ArrowRight className="ml-2 w-5 h-5" strokeWidth={1.5} data-id="element-170" />
              </Button>
              <a href="tel:925-215-1160" className="text-bc-bone-3 font-sans text-base hover:text-bc-bone transition-colors bc-ease" data-id="element-171">
                OR CALL 925-215-1160
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}